module.exports = __webpack_public_path__ + "media/images/bg-modal-basic-header-d4fbc97ab137ed6a1f67a7c7d17c559d.png";